// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

window.SpeechSDK = require('./distrib/lib/microsoft.cognitiveservices.speech.sdk.js');

